import HeroSection from "./HeroSection/HeroSection";
import { HomePageStyles } from "./HomePageStyles";
import HomePageCircles from "./HomePageCircles";
import { Box } from "@mui/material";

const HomePage = () => {
  return (
    <Box
      sx={{
        ...HomePageStyles.HomePageContainer,
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <HomePageCircles>
        <HeroSection />
      </HomePageCircles>
    </Box>
  );
};

export default HomePage;
